<template>
  <div class="comps-cardf-item" @click="$emit('click')">
    <div class="icon centerimage" ref="backimg"
      :style="'background-image: url(' + imgurl + ')'"><!-- 背景图 --></div>
    <p class="title to-2">{{title}}</p>
  </div>
</template>

<script>
export default {
  props: {
    imgurl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('../../../utils/color.less');
  .comps-cardf-item {
    width: 100%;
    background-color: #FFF;
    padding: 30px;
    .icon {
      width: 80px;
      height: 80px;
      margin: auto;
    }
    .title {
      font-family: Georgia, 宋体;
      text-align: center;
      margin: 20px 0 0;
      color: @silver;
    }
  }
  .comps-cardf-item:hover {
    background-color: @op-primary02;
    cursor: pointer;
    .title {
      color: @primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Models/comps/cardAreasB.vue